"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMonitoringTitle = getMonitoringTitle;
exports.ConnectedMonitoring = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactHotLoader = require("react-hot-loader");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _queryStringForAll = _interopRequireDefault(require("query-string-for-all"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _reactRedux = require("react-redux");

var _core = require("@lingui/core");

var _reactHelmet = require("react-helmet");

var routes = _interopRequireWildcard(require("../../../utils/routes"));

var _SubNav = require("../../../components/Analysis/SubNav");

var _Monitoring = require("../../../components/Analysis/Monitoring");

var _actionCreators = require("../../../redux/modules/monitoring/actionCreators");

var _actionCreators2 = require("../../../redux/modules/urlHistory/actionCreators");

var _selections = require("../../../redux/modules/_BETA/selections");

var _Page = require("../../../components/Layout/Page");

var _Loading = _interopRequireDefault(require("../../../components/Loading"));

var _utils = require("../../../components/Analysis/utils");

var _MonitoringEquips = _interopRequireDefault(require("../MonitoringEquips"));

const equipViewRE = /\/analysis\/(:?insights|monitoring)\/(.+)\/\d+/;
const ShowHideLayer = _styledComponents.default.div`
  display: ${props => props.isVisible ? 'block' : 'none'};
`;

const mapStateToProps = state => ({
  user: state.auth.user,
  appReady: state.appSetup.appSetupComplete,
  monitoring: state.monitoring,
  selectedSites: state.betaSelections.selectedSites,
  shouldRequestMonitoring: state.requestSchedule.shouldRequestMonitoring,
  daysRange: state.betaSelections.daysRange,
  showSnoozed: state.insights.showSnoozed
});

const mapDispatchToProps = {
  requestMonitoring: _actionCreators.loadMonitoring,
  updateHistory: _actionCreators2.updateMonitoringUrlHistory,
  updateTimeRange: _selections.updateDaysRange,
  setMultiSite: _selections.updateIsMultiSiteRoute
};

function getMonitoringTitle(i18n, category) {
  const trans = {
    all: i18n._({
      id: 'monitoring.all',
      message: 'All'
    }),
    data_uptime: i18n._({
      id: 'monitoring.data_uptime',
      message: 'Data Uptime'
    }),
    metering: i18n._({
      id: 'monitoring.metering',
      message: 'Metering'
    }),
    optimisation: i18n._({
      id: 'monitoring.optimisation',
      message: 'Optimisation'
    }),
    fdd: i18n._({
      id: 'monitoring.fdd',
      message: 'FDD'
    }),
    null: i18n._({
      id: 'monitoring.other',
      message: 'Other'
    })
  };
  return trans[category];
}

function onChangeCategory(history, updateHistory, setCategory) {
  return category => {
    setCategory(category);

    const qs = _queryStringForAll.default.parse(history.location.search);

    const stringified = _queryStringForAll.default.stringify({ ...qs,
      category
    });

    history.replace({
      search: stringified
    });
    updateHistory(history.location, history.action);
  };
}

const MonitoringScene = ({
  history,
  appReady,
  user,
  monitoring,
  requestMonitoring,
  shouldRequestMonitoring,
  updateHistory,
  updateTimeRange,
  daysRange,
  setMultiSite,
  selectedSites,
  showSnoozed
}) => {
  const [scrollPos, setScrollPos] = React.useState(0);
  const isEquipView = equipViewRE.exec(window.location.pathname) !== null;
  const handleScroll = (0, _lodash.default)(() => {
    if (!isEquipView) {
      setScrollPos(window.scrollY);
    }
  }, 300);
  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });
  React.useEffect(() => {
    if (!isEquipView) {
      window.requestIdleCallback(() => window.scroll(0, scrollPos));
    }
  }, [isEquipView]);
  React.useEffect(() => {
    if (appReady && selectedSites.length > 1) {
      setMultiSite(!isEquipView);
    }
  }, [selectedSites, appReady, isEquipView]);
  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (appReady && shouldRequestMonitoring) {
      requestMonitoring();
    }
  }, [shouldRequestMonitoring, appReady]);
  const defaultCategory = (0, _utils.getCategoryFromQueryString)(history.location.search);
  const [category, setCategory] = React.useState(defaultCategory);

  if (!appReady) {
    return null;
  }

  if (!user.groups.includes('Bueno')) return /*#__PURE__*/React.createElement(_reactRouterDom.Redirect, {
    to: "/actions"
  }); // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions

  if (monitoring.loading && !monitoring.ready) return /*#__PURE__*/React.createElement(_Page.Wrap, null, /*#__PURE__*/React.createElement(_Loading.default, null));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_reactHelmet.Helmet, {
    title: getMonitoringTitle(_core.i18n, category)
  }), /*#__PURE__*/React.createElement(ShowHideLayer, {
    isVisible: !isEquipView
  }, /*#__PURE__*/React.createElement(_SubNav.SubNav, {
    category: category,
    onChangeCategory: onChangeCategory(history, updateHistory, setCategory)
  }), /*#__PURE__*/React.createElement(_Page.Wrap, null, /*#__PURE__*/React.createElement(_Monitoring.Monitoring, {
    history: history,
    updateHistory: updateHistory,
    updateTimeRange: updateTimeRange,
    timeRange: daysRange,
    category: category,
    data: monitoring,
    showSnoozed: showSnoozed,
    isLoading: monitoring.loading
  }))), /*#__PURE__*/React.createElement(_reactRouterDom.Route, {
    exact: true,
    path: routes.MONITORING_EQUIPS,
    component: _MonitoringEquips.default
  }));
};

const ConnectedMonitoring = (0, _reactHotLoader.hot)(module)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MonitoringScene));
exports.ConnectedMonitoring = ConnectedMonitoring;